import { createContext, useState } from 'react';

type Props = {
  children: React.ReactNode;
};

export const WrapperContext = createContext<any>({});

export const Wrapper = ({ children }: Props) => {
  const [wrapperState, setWrapperState] = useState({});

  return (
    <div
      onClick={(e: any) => {
        if (!e.target.dataset.isselect) {
          setWrapperState({});
        }
      }}
    >
      <WrapperContext.Provider value={{ wrapperState, setWrapperState }}>
        {children}
      </WrapperContext.Provider>
    </div>
  );
};
